import { news, type NewsItem } from '@/mocks/news';
import { works, type WorkItem } from '@/mocks/works';
import { profile } from '@/mocks/profile';

export function getWorkById(id?: string): WorkItem | undefined {
  if (!id) return undefined;
  return works.find((w) => w.id === id);
}

export function getNewsById(id?: string): NewsItem | undefined {
  if (!id) return undefined;
  return news.find((n) => n.id === id);
}

export function getNewsForWork(workId: string): NewsItem[] {
  return news.filter((n) => n.relatedWorkId === workId);
}

export function getRelatedNews(current: NewsItem, limit = 3): NewsItem[] {
  const sameCategory = news.filter(
    (n) => n.id !== current.id && n.category === current.category,
  );
  const others = news.filter((n) => n.id !== current.id && n.category !== current.category);
  return [...sameCategory, ...others].slice(0, limit);
}

export function getWorksForNews(item: NewsItem): WorkItem[] {
  if (item.relatedWorkId) {
    const w = getWorkById(item.relatedWorkId);
    return w ? [w] : [];
  }
  return [];
}

export interface SearchResult {
  kind: 'news' | 'work' | 'profile';
  id: string;
  title: string;
  desc: string;
  path: string;
  meta: string;
  image?: string;
}

export function searchAll(keyword: string): SearchResult[] {
  const q = keyword.trim().toLowerCase();
  if (!q) return [];
  const results: SearchResult[] = [];

  news.forEach((n) => {
    const haystack = `${n.title} ${n.summary} ${n.category} ${n.content.join(' ')}`.toLowerCase();
    if (haystack.includes(q)) {
      results.push({
        kind: 'news',
        id: n.id,
        title: n.title,
        desc: n.summary,
        path: `/news/${n.id}`,
        meta: `${n.category} · ${n.date}`,
        image: n.thumb,
      });
    }
  });

  works.forEach((w) => {
    const haystack = `${w.title} ${w.titleEn} ${w.type} ${w.tags.join(' ')} ${w.synopsis} ${w.director} ${w.cast}`.toLowerCase();
    if (haystack.includes(q)) {
      results.push({
        kind: 'work',
        id: w.id,
        title: w.title,
        desc: w.synopsis,
        path: `/works/${w.id}`,
        meta: `${w.type} · ${w.year} 年`,
        image: w.cover,
      });
    }
  });

  const profileHaystack = `${profile.name} ${profile.nameEn} ${profile.nameJp} ${profile.tagline} ${profile.intro.join(' ')} ${profile.basicInfo
    .map((b) => `${b.label} ${b.value}`)
    .join(' ')}`.toLowerCase();
  if (profileHaystack.includes(q)) {
    results.push({
      kind: 'profile',
      id: 'profile',
      title: `${profile.name} · 明星资料`,
      desc: profile.intro[0],
      path: '/profile',
      meta: profile.tagline,
      image: profile.avatar,
    });
  }

  return results;
}